import { FC, MouseEventHandler } from 'react';

import CheckMarkIcon from '@o2/icons/CheckMark';
import CrossIcon from '@o2/icons/Cross';
import IconButton from '@o2/ui/IconButton';
import Stack from '@o2/ui/Stack';

export interface FieldListItemEditControlsProps {
  /**
   * Callback function for the Cancel button.
   *
   * If a value is not provided, the button will not be shown.
   */
  onCancel?: MouseEventHandler;

  /**
   * Callback function for the Save button.
   */
  onSave: MouseEventHandler;
}

/**
 * Default edit controls for FieldList.Item in editing mode.
 */
const EditControls: FC<FieldListItemEditControlsProps> = ({ onCancel, onSave }) => (
  // effectively, the visible gap is only 1.5 due to negative margins on the buttons
  <Stack gap={2} direction="row" my={0.5}>
    <IconButton color="primary" variant="squared-contained" onClick={onSave}>
      <CheckMarkIcon />
    </IconButton>
    {onCancel && (
      <IconButton color="primary" variant="squared" onClick={onCancel}>
        <CrossIcon />
      </IconButton>
    )}
  </Stack>
);

EditControls.displayName = 'FieldList.Item.EditControls';

export default EditControls;
